import { render } from "./index.vue?vue&type=template&id=8b735dde&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=8b735dde&lang=scss&scoped=true"

import exportComponent from "/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8b735dde"],['__file',"src/components/CardInfo/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "8b735dde"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('8b735dde', __exports__)) {
    console.log('reload')
    api.reload('8b735dde', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=8b735dde&scoped=true", () => {
    console.log('re-render')
    api.rerender('8b735dde', render)
  })

}


export default __exports__